export default "__VITE_ASSET__D1p5GhgX__"